import React, { useContext, useCallback, useEffect } from 'react';
import { SessionContext } from '../../contexts/session/SessionContext';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import useApi from '../../utils/useApi';
import { endpoints } from '../../utils/endpoints';
import { config } from '../../constants/config';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';

let logoutTimer: NodeJS.Timeout | undefined = undefined;

const clearLogoutTimer = () => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }
};

const SessionEndDialog = () => {
  const { showSessionEnd, setShowSessionEnd, updateToken } = useContext(SessionContext);
  const { post, get } = useApi(null);
  const { t } = useTranslation();

  const handleOnClickRefresh = useCallback(async () => {
    await get({ endpoint: endpoints.profile });
    setShowSessionEnd(false);
    clearLogoutTimer();
  }, [get, setShowSessionEnd]);

  const logOut = useCallback(async () => {
    try {
      await post({ endpoint: endpoints.logOut });
      updateToken(undefined);
      setShowSessionEnd(false);
    } catch (e) {}
  }, [post, setShowSessionEnd, updateToken]);

  useEffect(() => {
    if (showSessionEnd) {
      logoutTimer = setTimeout(logOut, config.logoutTimeout);
    } else {
      clearLogoutTimer();
    }
  }, [logOut, showSessionEnd]);

  return (
    <Dialog
      open={showSessionEnd}
      onClose={() => null}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{t(tPaths.sessionEndDialog.title)}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t(tPaths.sessionEndDialog.message)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={logOut} color="secondary">
          {t(tPaths.sessionEndDialog.logOut)}
        </Button>
        <Button onClick={handleOnClickRefresh} color="primary" autoFocus>
          {t(tPaths.sessionEndDialog.refresh)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionEndDialog;
